import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Download } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
export function PricingCTA() {
  const handleBuyClick = () => {
    trackEvent('AddToCart', {
      content_name: 'Semana Resuelta PDF',
      content_type: 'product',
      value: 9990,
      currency: 'ARS'
    });
  };
  return <Section className="pb-24" id="pricing" data-id="element-65">
      <div className="bg-white rounded-3xl shadow-xl border border-stone-100 overflow-hidden" data-id="element-66">
        <div className="bg-sage-light/30 p-8 md:p-12 text-center" data-id="element-67">
          <div className="inline-block px-4 py-1 mb-4 text-sm font-bold tracking-wider text-amber uppercase bg-amber/10 rounded-full" data-id="element-68">
            Oferta de lanzamiento
          </div>

          <div className="flex flex-col items-center gap-1 mb-6" data-id="element-69">
            <div className="flex items-baseline gap-2" data-id="element-70">
              <span className="text-2xl font-bold text-brown-body/40 line-through" data-id="element-71">
                $14.990
              </span>
            </div>
            <div className="flex items-baseline gap-1" data-id="element-72">
              <span className="text-2xl font-bold text-brown-body/60" data-id="element-73">$</span>
              <span className="text-6xl font-bold text-brown-heading" data-id="element-74">
                9.990
              </span>
              <span className="text-lg font-medium text-brown-body/60" data-id="element-75">
                ARS
              </span>
            </div>
          </div>

          <div className="space-y-2 mb-10 text-brown-body" data-id="element-76">
            <p data-id="element-77">
              Es menos que una compra improvisada que después te deja con culpa.
            </p>
            <p className="font-medium" data-id="element-78">
              Y mucho menos que el costo mental de decidir comida todos los
              días.
            </p>
          </div>

          <Button href="https://argrutinas.com/cart/42965772992721:1" onClick={handleBuyClick} className="w-full md:w-auto text-xl font-bold px-10 py-5 shadow-xl shadow-sage/20 mb-6" data-id="element-79">
            Hacé clic y descargalo ahora
            <Download className="ml-2 w-6 h-6" data-id="element-80" />
          </Button>

          <p className="text-sm text-brown-body/70 max-w-md mx-auto" data-id="element-81">
            Hoy mismo podés cerrar tu semana en 30 minutos y dejar de pelearte
            con la heladera.
          </p>
        </div>

        <div className="bg-stone-50 p-6 text-center border-t border-stone-100" data-id="element-82">
          <p className="text-xs text-stone-500 max-w-2xl mx-auto leading-relaxed" data-id="element-83">
            Disclaimer: Este producto es educativo y de organización. No
            reemplaza consejo médico. Si tomás medicación, consultá ante cambios
            importantes.
          </p>
        </div>
      </div>
    </Section>;
}